var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ViewService } from '../../view.service';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject } from 'rxjs';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { ViewState } from '../../state/view.state';
import { takeUntil } from 'rxjs/operators';
export class ViewContentModeComponent {
    // ---------- Lifecyle Events ----------
    constructor(store, viewService, layoutService, changeDetectorRef) {
        this.store = store;
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.changeDetectorRef = changeDetectorRef;
        this.ngUnsubscribe = new Subject();
        // ---------- Input / Output ----------
        this.layout = 'column';
        // ---------- Class Variables ----------
        this.viewLayout = ViewLayout;
    }
    ngOnInit() {
        this.store
            .select(ViewState.getLayout)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.changeDetectorRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    // ---------- Layout ----------
    isVisible(layout) {
        return this.layoutService.isLayoutVisible(layout);
    }
    isEnabled(layout) {
        return this.layoutService.isLayoutEnabled(layout);
    }
    // ---------- Interaction ----------
    handlePrevClick() {
        this.selectLabel(-1);
    }
    handleNextClick() {
        this.selectLabel(1);
    }
    selectLabel(increment) {
        const labels = this.store.selectSnapshot(StoryLabelsState.getChapterLabels);
        const labelCount = labels.length;
        const selectedLabelId = this.store.selectSnapshot(StoryLabelsState.getSelectedLabelId);
        const selectedLabelIndex = labels.findIndex((label) => label.id === selectedLabelId);
        // get next index
        const nextIndex = selectedLabelIndex !== -1
            // increment
            ? selectedLabelIndex + increment
            // defafult
            : 0;
        // cycle target index in range
        const targetLabelIndex = (nextIndex % labelCount + labelCount) % labelCount;
        // get target label
        const targetLabel = labels[targetLabelIndex];
        if (targetLabel) {
            this.viewService.selectLabel(targetLabel, true);
        }
    }
}
__decorate([
    Select(StoryChaptersState.getStoryChapters),
    __metadata("design:type", Observable)
], ViewContentModeComponent.prototype, "chapters$", void 0);
__decorate([
    Select(StoryLabelsState.getChapterLabels),
    __metadata("design:type", Observable)
], ViewContentModeComponent.prototype, "labels$", void 0);
